export default __webpack_public_path__ + "images/6d40e4c6eeb27549ce800b7957ecde10-blues_and_jazz_small.webp";